import * as React from 'react';
import { Box, Typography } from '@mui/material';
import { Doughnut } from 'react-chartjs-2';
import { ArcElement, Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

import { IChartData } from 'models';

ChartJS.register(ArcElement, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

interface DoughnutChartProps {
  data: IChartData;
  size?: number;
  value?: number;
  valueUnit?: string;
}

export const DoughnutChart: React.FC<DoughnutChartProps> = (props) => {
  const { data, size = 180, value = 0, valueUnit = '' } = props;

  const options = {
    responsive: true,
    type: 'doughnut',
    cutout: '80%',
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
      },
    },
  };

  return (
    <Box
      sx={{
        position: 'relative',
        width: size,
        height: size,
      }}
    >
      <Doughnut options={options} data={data as any} />

      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            textAlign: 'center',
          }}
        >
          <Typography
            variant="h3"
            sx={{
              fontWeight: 700,
            }}
          >
            {value}
          </Typography>
          <Typography variant="subtitle2" component="div" color="text.secondary">
            {valueUnit}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
